// type Phase_D = {
//     step:  string;
//     title: string;
//     text:  string[];
// };

// type Phase_E = {
//     step:        string;
//     title:       string;
//     description: string;
//     text:        string[];
// };

// type Phase_B = {
//     step: string;
//     expectations:
//         {
//             id:      string;
//             heading: string;
//             benchmarks:
//                 {
//                     id:   string;
//                     text: string;
//                     subBenchmarks: 
//                         {
//                             id:              string;
//                             phase:           object;
//                             checklistItems:  string[];
//                             feedback:        string;
//                             type:            string;
//                         }[];
//                 }[];
//         }[];
// };

// type Phase_R = {
//     step:    string;
//     slides:  string[] | { text: { __html: string; linkHoverText: object; }}[];
// };

// type Phase_F = {
//     step:      string;
//     title:     string;
//     heading:   string;
//     questions: string;
// };

// type Step_Data = [Phase_D, Phase_E, Phase_B, Phase_R, Phase_F];

// export const STEP_DATA: Step_Data = [

    import {link, para, text} from "./utils"

    export const B4CA_PhaseDEBRF = [
        {
            step: "D",
            title: "Define Rules:",
            text: ["The purpose of this debriefing is to reflect on the scenario you have just completed in order to help you improve your skills as a paramedic.  It is not meant to assess your overall abilities as a paramedic.", "This debriefing will summarize the learning objectives of this scenario and the performance benchmarks (standards) for achieving each objective.  The system will then prompt you to examine differences between the treatment actions that you performed and those indicated by the clinical findings revealed during the scenario, or that would have been revealed by a more thorough assessment and reassessment of this patient.  Finally, it will prompt you to state some 'take home points' to improve your performance."]
        },
        {
            step: "E",
            title: "Explain the learning objectives:",
            description: "This scenario was designed to give you practice with:",
            text: [
                "Conducting a thorough trauma patient assessment",
                "Managing severe external bleeding",
                "Managing inadequate breathing",
                "Managing hemorrhagic shock",
                "Making appropriate transport decisions",
                "Performing ongoing patient management and assessment",
            ]
        },
        {
            step: "B",
            expectations: [
                {
                    expectationText: "Conduct a thorough trauma assessment",
                    benchmarks: [
                        {
                            benchmarkText: "Before approaching patient, apply PPE, check that the scene is safe, determine the number of patients, and request additional help if necessary",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "On initial patient contact, form a general impression of the patient's condition, assess patient's level of consciousness, and identify apparent life threats",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "During the Primary Survey:",
                            subBenchmarks: 
                            [
                                "Check that airway is open, clear of fluids and foreign bodies, and has intact physical structures", 
                                "Listen for abnormal breath sounds and check breathing rate, rhythm, and quality", 
                                "Check circulation: pulse rate/rhythm/quality; skin color/temperature/condition; perform gross blood sweep",
                                "Determine the need for rapid transport",
                                "Trauma expose patient"
                            ]
                        },
                        {
                            benchmarkText: "Take baseline vitals and, if possible, obtain SAMPLE history and OPQRST",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Perform a rapid head-to-toe assessment (Secondary Survey), looking/listening/feeling for DCAP-BTLS and abnormal conditions at each body part (e.g., check neck for tracheal deviation and JVD).",
                            subBenchmarks: []
                        },
                    ]
                },
                {
                    expectationText: "Manage a potential head or spinal injury",
                    benchmarks: [
                        {
                            benchmarkText: "Identify the potential for head or spinal injury during your initial assessment",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Direct manual stabilization of the cervical spine before checking airway, breathing and circulation",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Apply an appropriately sized cervical collar",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: " Immobilize the patient prior to transport by log-rolling the patient onto a backboard and attaching at least three straps, the CID pad, both head blocks, and CID straps",
                            subBenchmarks: []
                        },
                    ]
                },
                {
                    expectationText: "Manage inadequate breathing due to a simple pneumothorax",
                    benchmarks: [
                        {
                            benchmarkText: "Diagnose a simple pneumothorax during the primary survey",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Provide concentrated O2 via a non-rebreather mask or, if not tolerated, a nasal cannula",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Titrate oxygen to SpO2 of 95-99%",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Do NOT attempt needle decompression",
                            subBenchmarks: []
                        },
                    ]
                },
                {
                    expectationText: "Make appropriate transport decisions",
                    benchmarks: [
                        {
                            benchmarkText: "Rapid transport to a Level 1 trauma facility by ground ambulance, using lights and sirens",
                            subBenchmarks: []
                        },
                    ]
                },
                {
                    expectationText: "Perform ongoing patient management and assessment",
                    benchmarks: [
                        {
                            benchmarkText: "Splint the patient's wrist and apply a sling to his injured shoulder before transferring him to an immobilization device and then to the ambulance.",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Reassess vitals every 5 minutes; repeat primary and secondary survey",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Establish at least one large bore IV en route",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Administer pain medication en route if time allows",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Keep the patient warm by covering the patient with blankets, turning the heat up in the ambulance, applying heat packs, etc.",
                            subBenchmarks: []
                        },
                        {
                            benchmarkText: "Contact receiving facility.  Provide complete report on patient's condition and ETA",
                            subBenchmarks: []
                        },
                    ]
                }
            ]
        },
        {
            step: "R",
            slides: [
                {
                    paragraphs: [
                        para(
                            text("In an idealized scenario, you arrive on scene and find a man dressed in motocross gear lying on the ground. Your initial assessment reveals a helmeted patient who is awake and alert with shallow breaths.")
                        ),
                        para(
                            text("You immediately direct your partner to provide"),
                            link("manual c-spine stabilization", "Spinal precautions should be taken with any patient involved in a motor-vehicle accident or any instance where a patient was thrown."),
                            text("while removing the helmet and apply a cervical collar. You note the patient has an open airway and that his breathing is rapid and shallow, so you place him on either a"),
                            link("non-rebreather mask or nasal cannula.", "While this patient is in mild respiratory distress and has hypoxia, his mental status and respiratory effort are appropriate, so he does not need assistance with ventilation."),
                            text("His extremity pulses are strong.")
                        )
                    ]
                },
                {
                    paragraphs: [
                        para(
                            text("You instruct another responder to obtain a set of baseline vitals and obtain a SAMPLE and OPQRST history from the race official while you perform a rapid head-to-toe assessment. You note that the patient has diminished breath sounds on the left but"),
                            link("no signs of decreased cardiac output.", "This patient has a pneumothorax, as evidenced by his hypoxia and unequal breath sounds, but without evidence of decreased cardiac output (ex. JVD, hypotension), he does not have a tension pneumothorax and does not require needle decompression at this time."),
                            text("After checking the patient’s anterior, you and your partner log roll the patient, check his posterior, and secure him onto a long back board.")
                        ),
                        para(
                            text("Once the CID is in place, you and your partners then place the patient on a stretcher, cover him with a blanket, and transfer him to the ambulance. You notify the Level I trauma center you are on the way. En route, you establish two large bore IVs, reassess the patient"),
                            link("every five minutes,", "Critically ill patients should be reassessed every 5 minutes."),
                            text("and confirm that all interventions are working properly, modifying any as necessary.")
                        )
                    ]
                }
                        
            ]
        },
        {
            step: "F",
            title: "Formalize learning",
            heading: "Please take a few minutes to think and reply to these questions",
            questions: "What are your key take-home points from this case? What is something you want to continue working on or do differently in the future?"
        }
    ];